import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Location } from 'models/locations';

import CurrencySymbol from 'components/common/currency-symbol';

const propTypes = {
  amount: PropTypes.string,
  label: PropTypes.string.isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  totalStyle: PropTypes.string,
};

const defaultProps = {
  totalStyle: null,
  amount: null,
};

const OrderTotal = ({ totalStyle, amount, label, location }) => {
  const priceLength = Math.floor(amount).toString().length;
  const descriptionColumns = cx({
    'col-xs-7': (priceLength <= 2),
    'col-xs-6': (priceLength > 2),
  });
  const priceColumns = cx({
    'col-xs-5': (priceLength <= 2),
    'col-xs-6': (priceLength > 2),
  });
  const labelClassNames = cx({
    'text-size-sm-24 text-size-xs-18': (priceLength <= 2),
    'text-size-xs-20': (priceLength > 2),
  });

  let formattedTotal;
  if (totalStyle === 'inline') {
    formattedTotal = (
      <span className="text-size-sm-42 text-size-xs-36">
        <sup>
          <CurrencySymbol location={location} />
        </sup>
        { Number(amount).toFixed(2) }
      </span>
    );
  } else {
    formattedTotal = (
      <span className="text-size-sm-42 text-size-xs-36">
        <sup>
          <CurrencySymbol location={location} />
        </sup>
        { Math.floor(amount) }
        <sup>
          { Number(amount % 1).toFixed(2).replace(/^0\.+/, '') }
        </sup>
      </span>
    );
  }

  return (
    <div className="row">
      <div className={`${descriptionColumns} col-print-5 col-gutter-right-0 order-total-description`}>
        <div className={`${labelClassNames} text-weight-book text-color-dark-slate`}>
          {label}
        </div>
      </div>
      <div className={`${priceColumns} col-print-7 col-gutter-left-0 order-total-amount`}>
        <div className="text-weight-book text-color-dark-slate line-height-full text-align-right">
          {formattedTotal}
        </div>
      </div>
    </div>
  );
};

OrderTotal.propTypes = propTypes;
OrderTotal.defaultProps = defaultProps;

export default OrderTotal;
